module.exports = __webpack_public_path__ + "static/media/luchador.6bc8abfb.svg";